<div class="card-body">
  <h6 style="text-align: center;">
    Expired quotes will be removed after 1 year. Click the Update button to keep any expired quote active and accessible in KawneerDirect.
  </h6>
  <p class="card-text"></p>
</div>
<kendo-grid [data]="gridSettings?.gridData"
            class="kdQuoteGridCls"
            [sortable]="true"
            [selectable]="false"
            [navigable]="true"
            [filterable]="true"
            [groupable]="false"
            [reorderable]="true"
            [resizable]="true"
            [sort]="gridSettings.state.sort"
            [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
            [pageSize]="gridSettings.state.take"
            [skip]="gridSettings.state.skip"
            [columnMenu]="{ filter: true }"
            (sort)="kdQuoteGridSortChange($event)"
            (pageChange)="kdQuoteGridPageChange($event)"
            (dataStateChange)="kdQuoteDataStateChange($event)"
            (columnReorder)="onReorder($event)"
            (columnVisibilityChange)="onVisibilityChange($event)"
            [filter]="gridSettings.state.filter"
            [loading]="kdQuoteLoading">
  <ng-template kendoGridToolbarTemplate>
    <div class="k-grid-toolbar-button-display btn-web">
      <button kendoButton [icon]="'plus'" class="btn buttonSize" [selected]="true" (click)="toggleQuoteDialog()">
        {{kdQuoteTxt.addNewQuoteLbl?kdQuoteTxt.addNewQuoteLbl:kdQuote.addNewQuoteLbl}}
      </button>
      <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()" style="margin-left: 746px;">
        {{kdQuoteTxt.exportToExcelLbl?kdQuoteTxt.exportToExcelLbl:kdQuote.exportToExcelLbl}}
        <kendo-loader *ngIf="loadingExcel"></kendo-loader>
      </button>
      <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generatePDF()">
        {{kdQuoteTxt.exportToPdfLbl?kdQuoteTxt.exportToPdfLbl:kdQuote.exportToPdfLbl}}
        <kendo-loader *ngIf="loadingPDF"></kendo-loader>
      </button>
    </div>
    <div class="row pwa-addNew">
      <div class="col-12 paddingZero">
        <button kendoButton [icon]="'plus'" class="btn buttonSize" [selected]="true" (click)="toggleQuoteDialog()">
          {{kdQuoteTxt.addNewQuoteLbl?kdQuoteTxt.addNewQuoteLbl:kdQuote.addNewQuoteLbl}}
        </button>
      </div>
    </div>
    <div class="row pwaKDQuoteSearch" style="width:100%;">
      <div class="col-sm-3 col-md-2 paddingZero" style="padding-top:2px;">
        {{kdQuote.quoteDateLbl}}:
      </div>
      <div class="col-sm-9 col-md-5  paddingZero">
        <app-grid-daterange-pwa-filter class="date-range-filter"
                                       [filter]="gridSettings.state.filter"
                                       field="quoteDate">
        </app-grid-daterange-pwa-filter>
      </div>
      <div class="col-sm-12 col-md-5  paddingZero">
        <input placeholder="Search in all columns..."
               kendoTextBox
               (input)="onFilterKDQuotes($event.target.value)" class="searchClass" [(ngModel)]="searchTextKDQuote" />
      </div>

    </div>



  </ng-template>
  <!--Redirect to quote details on quote number click   [routerLink]="['/manage-quote/kawneerdirect-quotes/quote-detail']"-->
  <kendo-grid-column media="(max-width: 1024px)" title="KawneerDirect Quote">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="row mb-3">

        <div class="col-9 job-name">

          <a class="links" (click)="goToQuoteDetail('/manage-quote/kawneerdirect-quotes/quote-detail',dataItem)" *ngIf="dataItem.status==='Active'">
            {{dataItem.jobNumber}}
          </a>
          <span *ngIf="dataItem.status==='Expired'">{{dataItem.jobNumber}}</span>
          <span class="txt-bold"> - {{dataItem.jobName}} </span>

        </div>
        <div class="col-3 paddingZero textRight">
          <button class="k-button k-grid-remove actionBtnCls" (click)="printMaterialProposal(dataItem)"
                  [disabled]="dataItem.updateInProgress"
                  *ngIf="dataItem.status==='Active'">
            <span class="k-icon k-i-print">
            </span>
          </button>

          <button class="k-button k-grid-print actionBtnCls"
                  (click)="removeConfirmation(dataItem)" [disabled]="dataItem.updateInProgress"
                  *ngIf="dataItem.status==='Active'">
            <span class="k-icon k-i-trash">
            </span>
          </button>

          <button class="k-button k-grid-redo actionBtnCls"
                  (click)="openTransferDialog(dataItem)" [disabled]="dataItem.updateInProgress"
                  *ngIf="(dataItem.status==='Active' && dataItem.doesQuoteHasError== false)">
            <span class="k-icon k-i-redo">
            </span>
          </button>

          <button class="k-button k-grid-update " (click)="updateRow(dataItem)"
                  *ngIf="dataItem.status==='Expired'" [disabled]="dataItem.updateInProgress">
            {{kdQuoteTxt.updateLbl?kdQuoteTxt.updateLbl:kdQuote.updateLbl}}
          </button>

        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{kdQuote.marketSegmentLbl}}:</span> <span class="float-right-pwa"> {{dataItem.marketSegment}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{kdQuote.revlbl}}:</span> <span class="float-right-pwa"> {{dataItem.revision}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{kdQuote.leedLbl}}:</span> <span class="float-right-pwa"> {{dataItem.leed ? "Y" : "N"}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{kdQuote.quoteDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.quoteDateForDisplay}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{kdQuote.expirationDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.expirationDateForDisplay}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{kdQuote.statusLbl}}:</span> <span class="float-right-pwa"> {{dataItem.status}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{kdQuote.totalBaseBidLbl}}:</span> <span class="float-right-pwa"> {{dataItem.totalBaseBid | currency}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero"></div>
        <div class="col-sm-4 col-md-4 paddingZero"></div>
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column *ngFor="let col of gridSettings.columnsConfig"
                     [field]="col.field"
                     [title]="col.title"
                     [filter]="col.filter"
                     [filterable]="col.filterable"
                     [hidden]="col.hidden"
                     [format]="col.format" media="(min-width: 1025px)">
    <ng-template kendoGridCellTemplate let-column="column" *ngIf="col.field == 'jobNumber'" let-dataItem>
      <a class="links"
         (click)="goToQuoteDetail('/manage-quote/kawneerdirect-quotes/quote-detail',dataItem)" *ngIf="col.field == 'jobNumber' && dataItem.status==='Active'">
        {{dataItem.jobNumber}}
      </a>
      <span *ngIf="col.field == 'jobNumber' && dataItem.status==='Expired'">{{dataItem.jobNumber}}</span>
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'leed'">
      <app-grid-dropdown-filter [filter]="filter" [data]="leedData" textField="name" valueField="leed">
      </app-grid-dropdown-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'leed'">
      {{dataItem.leed ? "Y" : "N"}}
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'marketSegment'">
      <app-grid-dropdown-filter [filter]="filter" [data]="marketSegments" textField="name" valueField="marketSegment">
      </app-grid-dropdown-filter>
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'quoteDateForDisplay'">
      <app-grid-daterange-filter class="date-range-filter" [filter]="filter" field="quoteDate">
      </app-grid-daterange-filter>
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'expirationDateForDisplay'">
      <app-grid-daterange-filter class="date-range-filter" [filter]="filter" field="expirationDate">
      </app-grid-daterange-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-column="column" let-dataItem *ngIf="col.field == 'totalBaseBid'">
      {{dataItem.totalBaseBid | currency}}
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem
                 *ngIf="col.field == 'status'">
      <app-grid-dropdown-filter [filter]="filter" [data]="statusData" textField="name" valueField="status">
      </app-grid-dropdown-filter>
    </ng-template>
  </kendo-grid-column>

  <!--<kendo-grid-column field="jobNumber" title="{{kdQuoteGridColumnLbl.jobNumber}}">
    <ng-template kendoGridCellTemplate let-column="column" let-dataItem>
      <a class="links" href="javascript:void"
         (click)="goToQuoteDetail('/manage-quote/kawneerdirect-quotes/quote-detail',dataItem)">
        {{dataItem.jobNumber}}
      </a>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="revision" title="{{kdQuoteGridColumnLbl.revision}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="jobName" title="{{kdQuoteGridColumnLbl.jobName}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="leed" title="{{kdQuoteGridColumnLbl.leed}}" [width]="100">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-grid-dropdown-filter [filter]="filter" [data]="leedData" textField="name" valueField="value">
      </app-grid-dropdown-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
      {{dataItem.leed ? "Y" : "N"}}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="marketSegment" title="{{kdQuoteGridColumnLbl.marketSegment}}" [width]="180">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-grid-dropdown-filter [filter]="filter" [data]="marketSegments |async" textField="name" valueField="value">
      </app-grid-dropdown-filter>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="quoteDateForDisplay"
                     filter="date"
                     format="{0:d}"
                     title="{{kdQuoteGridColumnLbl.quoteDate}}"
                     [width]="220">-->
  <!--<ng-template kendoGridCellTemplate class="d-super-center" let-dataItem>
    <span>{{dataItem}}</span>
  </ng-template>-->
  <!--<ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-grid-daterange-filter class="date-range-filter" [filter]="filter" field="quoteDateForDisplay">
      </app-grid-daterange-filter>
    </ng-template>
  </kendo-grid-column>-->
  <!--[format]="{date:{ month: 'numeric', day: 'numeric', year: 'numeric'}}"-->
  <!--<kendo-grid-column field="expirationDateForDisplay"
                     filter="date"
                      format="{0:d}"

                     title="{{kdQuoteGridColumnLbl.expiredDate}}" [width]="220">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-grid-daterange-filter class="date-range-filter" [filter]="filter" [field]="expirationDateForDisplay">
      </app-grid-daterange-filter>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="totalBaseBid" [filterable]="false" title="{{kdQuoteGridColumnLbl.totalBaseBid}}">
    <ng-template kendoGridCellTemplate let-column="column" let-dataItem>
      {{dataItem.totaBaselBid | currency}}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="status" title="{{kdQuoteGridColumnLbl.status}}" [width]="100">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
      <app-grid-dropdown-filter [filter]="filter" [data]="statusData" textField="name" valueField="value">
      </app-grid-dropdown-filter>
    </ng-template>
  </kendo-grid-column>-->
  <kendo-grid-command-column [resizable]="false"
                             [width]="170"
                             title="{{kdQuoteGridColumnLbl.actions}}"
                             [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                             [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}" media="(min-width: 1025px)">
    <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem>
      <div class="action-icons" >
      <button class="k-button actionBtnCls" (click)="printMaterialProposal(dataItem)"
              [disabled]="dataItem.isLocked || dataItem.updateInProgress"
              *ngIf="(dataItem.status==='Active' && dataItem.doesQuoteHasError== false)">
        <span class="k-icon k-i-print">
        </span>
      </button>
      
      <button class="k-button k-grid-remove-command actionBtnCls"
              (click)="removeConfirmation(dataItem)" [disabled]="dataItem.isLocked ||dataItem.updateInProgress"
              *ngIf="(dataItem.status==='Active' && dataItem.doesQuoteHasError== false)">
        <span class="k-icon k-i-trash">
        </span>
      </button>

      <button class="k-button actionBtnCls"
              (click)="openTransferDialog(dataItem)" [disabled]="dataItem.isLocked ||dataItem.updateInProgress"
              *ngIf="(dataItem.status==='Active' && dataItem.doesQuoteHasError== false)">
        <span class="k-icon k-i-redo">
        </span>
      </button>
      <button class="k-button actionBtnCls" (click)="updateRow(dataItem)"
              *ngIf="(dataItem.status==='Expired')" [disabled]="dataItem.updateInProgress">
        {{kdQuoteTxt.updateLbl?kdQuoteTxt.updateLbl:kdQuote.updateLbl}}
      </button>
      </div>
      <span title="{{kdQuoteGridColumnLbl.invalidQuotetext}}/{{dataItem.errorMessage}}" *ngIf="dataItem.status==='Active' && dataItem.doesQuoteHasError === true" kendoTooltip
            class="k-icon k-i-information k-i-info spanInfoIconCls" style="color:Red"></span>
      <kendo-loader *ngIf="dataItem.updateInProgress" style="color:blue"></kendo-loader>
    </ng-template>
  </kendo-grid-command-column>
  <ng-template kendoGridNoRecordsTemplate>
  </ng-template>
  <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
    <kendo-pager-info></kendo-pager-info>
    <kendo-pager-next-buttons></kendo-pager-next-buttons>
    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
  </ng-template>-->
</kendo-grid>
<app-ca-prop></app-ca-prop>

<Section class="dialogSection">
  <!-- this is for Edit Dialog  -->
  <kendo-dialog title="{{kdQuoteTxt.addNewQuoteLbl?kdQuoteTxt.addNewQuoteLbl:kdQuote.addNewQuoteLbl}}" *ngIf="quoteDialog.opened" (close)="toggleQuoteDialog()">
    <div class="container-fluid">
      <form [formGroup]="addQuoteForm" autocomplete="off">

        <div class="form-row">
          <div class="form-group col-md-12">
            <label>
              {{kdQuoteTxt.jobNameLbl?kdQuoteTxt.jobNameLbl:kdQuote.jobNameLbl}} <span class="requiredField">*</span>
            </label>
            <input type="text" kendoTextBox class="kendoInput" name="jobName" (blur)="validateAddQuoteForm()"
                   formControlName="jobName"
                   [ngClass]="{'borderRed':quoteDialog.isInvalidQuoteName && quoteDialog.isSubmitted}" [maxlength]="30" />
          </div>
          <div class="form-group col-md-12">
            <label>
              {{kdQuoteTxt.marketSegmentLbl?kdQuoteTxt.marketSegmentLbl:kdQuote.marketSegmentLbl}} <span class="requiredField">*</span>
            </label>
            <kendo-dropdownlist [data]="marketSegmentsDropdownData" formControlName="marketSegment"
                                (blur)="validateAddQuoteForm()" textField="name" valueField="value" class="kendoInput"
                                [ngClass]="{'borderRed':quoteDialog.isInvalidManageSegment && quoteDialog.isSubmitted}" (selectionChange)="marketSegmentChange($event)">
            </kendo-dropdownlist>

          </div>
          <div class="form-group col-md-12">

            <!-- <input type="checkbox" class="k-checkbox" /> -->
            <label class="leedLbl">{{kdQuoteTxt.leedLbl?kdQuoteTxt.leedLbl:kdQuote.leedLbl}} </label>
            <kendo-switch formControlName="leed" [onLabel]="'Yes'" [offLabel]="'No'" class="leedSwitchCls">
            </kendo-switch>
            <!-- [for]="leed" -->
          </div>

        </div>

        <div class="dialog-btn-section">
          <div class="row">
            <div class="col-sm-12 float-left">
              <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 btn-align-center">
              <div class="btn-group" role="group">
                <button (close)="toggleQuoteDialog()" (click)="toggleQuoteDialog()" class=" m-3 btn k-button dialogBtnSize" kendoButton>
                  {{kdQuoteTxt.closeLbl?kdQuoteTxt.closeLbl:kdQuote.closeLbl}}
                </button>
                <button (click)="saveQuoteData()" class="m-3 btn btn-success dialogBtnSize" kendoButton
                        [disabled]="saveInProcess">
                  {{kdQuoteTxt.saveLbl?kdQuoteTxt.saveLbl:kdQuote.saveLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </kendo-dialog>

</Section>
<section>
  <kendo-dialog title="Please confirm" *ngIf="showQuoteDeleteConfirmBox" (close)="confirmQuoteRemove(false)">
    <p style="margin: 30px; text-align: center;">
      {{kdQuoteTxt.deleteConfirmLbl?kdQuoteTxt.deleteConfirmLbl:kdQuote.deleteConfirmLbl}}
      {{ gridQuoteToRemove.jobName }}?
    </p>
    <kendo-dialog-actions>
      <button class='k-button' (click)="confirmQuoteRemove(false)">
        {{kdQuoteTxt.noLbl?kdQuoteTxt.noLbl:kdQuote.noLbl}}

      </button>
      <button class='k-button k-primary' (click)="confirmQuoteRemove(true)" primary="true">
        {{kdQuoteTxt.yesLbl?kdQuoteTxt.yesLbl:kdQuote.yesLbl}}

      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</section>

<!-- Transfer Quote popup in progress Arpita-->
<Section class="dialogSection">
  <!-- this is for Edit Dialog  -->
<kendo-dialog title="{{kdQuoteTxt.transferQuoteLbl?kdQuoteTxt.transferQuoteLbl:kdQuote.transferQuoteLbl}}" *ngIf="quoteTransferDialog?.opened " (close)="toggleTransferQuoteDialog()">
  <div class="container-fluid">
    <form [formGroup]="addQuoteForm" autocomplete="off">
     
      <div class="form-row">
        <div class="form-group col-md-12">
          <!--  <label *ngIf="col.field == 'jobNumber' && dataItem.status==='Active'" let-dataItem>-->
          <label style="text-align: center; font-size: 15px;">
            Transfer quote {{selectedJobNumber}} ({{selectedJobName}}) to active account:
          </label>
         
          <kendo-dropdownlist [data]="companyUsersDropdownData" formControlName="companyUsers"
                              (blur)="validateAddQuoteForm()" textField="name" valueField="value" class="kendoInput"
                              [ngClass]="{'borderRed':quoteTransferDialog.isUserUpdated && quoteTransferDialog.isSubmitted}" (selectionChange)="UserChange($event)">
          </kendo-dropdownlist>
          
        </div>
          <div class="form-group col-md-12" >
             {{kdQuoteTxt.noteLbl?kdQuoteTxt.noteLbl:kdQuote.noteLbl}} 
          </div>

        </div>

        <div class="dialog-btn-section">
          <div class="row">
            <div class="col-sm-12 float-left">
              <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 btn-align-center">
              <div class="btn-group" role="group">
                <button (click)="toggleTransferQuoteDialog()" class=" m-3 btn k-button dialogBtnSize" kendoButton>
                  {{kdQuoteTxt.closeLbl?kdQuoteTxt.closeLbl:kdQuote.closeLbl}}
                </button>
                <button (click)="submitUpdatedQuoteData()" class="m-3 btn btn-success dialogBtnSize" kendoButton
                        [disabled]="saveInProcess">
                  {{kdQuoteTxt.submitLbl?kdQuoteTxt.submitLbl:kdQuote.submitLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </kendo-dialog>

  </Section> 

